import { Result, Button, Flex, Image, Typography, Divider } from "antd";
import { Link } from "react-router-dom";
import BannerSeller from "@/assets/img/seller-banner.png";
import xconsLogo from "@/assets/img/logo-xcons.webp";

const { Text, Title } = Typography;

export const SellersPage = () => {
  return (
    <Flex justify="center" align="center" vertical gap={80}>
      <Flex vertical>
        <Flex
          align="center"
          vertical
          style={{
            backgroundImage: `url(${BannerSeller})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width: 965,
            height: 304,
          }}
        >
          <Flex
            justify="center"
            vertical
            style={{
              padding: 16,
              borderRadius: 20,
              width: 700,
              marginTop: 10,
            }}
          >
            <Title level={1} style={{ color: "#15744B", margin: 0 }}>
              Sellers
            </Title>
            <Divider
              style={{
                height: 5,
                backgroundColor: "#85D025",
                width: 279,
                minWidth: "auto",
                margin: "8px 0",
                borderRadius: 100,
                border: "none",
              }}
            />

            <Title
              level={3}
              style={{
                margin: "24px 0 0 0",
                border: "1px solid #AEAEAE",
                borderRadius: 90,
                padding: "8px 24px",
                width: "fit-content",
              }}
            >
              Tu operación, tus ventas.
            </Title>
            <Title level={5}>
              Ya seas una gran empresa o un pequeño distribuidor, podés <br />
              participar en múltiples Stores simultáneamente y expandir tu{" "}
              <br />
              alcance sin límites.
            </Title>
          </Flex>
        </Flex>
        <Flex
          vertical
          style={{
            border: "1px solid #AEAEAE",
            borderTop: "none",
            borderRadius: "0 0 20px 20px",
            width: 965,
            marginTop: "-10px",
            padding: "24px 16px",
          }}
        >
          <Text strong>Como Seller en XCONS podés:</Text>

          <Text style={{ marginTop: 16 }}>
            Asociar tus productos al catálogo de los Stores donde participes.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />

          <Text style={{ marginTop: 16 }}>
            Configurar métodos de entrega y medios de pago.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />

          <Text style={{ marginTop: 16 }}>
            Gestionar cada venta desde la confirmación hasta la entrega.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />

          <Text style={{ marginTop: 63 }}>
            ¿Querés saber cómo va a funcionar? Leelo aquí:{" "}
            <Link
              to="https://service.xcons.com/odoo/knowledge/210"
              target="_blank"
            >
              Documentación
            </Link>
          </Text>
        </Flex>
      </Flex>

      <img src={xconsLogo} alt="XCONS logo" style={{ width: 200 }} />
    </Flex>
  );
};
